import { NgModule } from '@angular/core';
import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { TamasAlunoService } from '../tamas-aluno.service';
import { Router } from '@angular/router';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { AlertaSimplesDialog } from '../alerta-simples';
import { AlertaInputDialog } from '../alerta-input';
import { AlertaConfirmDialog } from '../alerta-confirm';
import {Location} from '@angular/common';
import { DatePipe } from '@angular/common';
import { AlertaTermosDialog } from '../alerta-termos';

@Component({
    selector: 'app-cadastrar',
    templateUrl: './cadastrar.component.html',
    styleUrls: ['./cadastrar.component.css'],
    providers : [DatePipe]
  })

export class CadastrarComponent implements OnInit, OnDestroy {
    @ViewChild("nomeInput") nomeInput: ElementRef;
    @ViewChild("nascimentoInput") nascimentoInput: ElementRef;
    @ViewChild("celularInput") celularInput: ElementRef;
    @ViewChild("emailInput") emailInput: ElementRef;
    @ViewChild("emailconfInput") emailconfInput: ElementRef;
    
    nome: any = '';
    email: any = '';
    emailconf: any = '';
    senha: any = '';
    nascimento: any = '';
    genero: any = '';
    celular: any = '';
    celular2: any = '';
    newsletter: boolean = true;
    shouldHide: boolean = true;
    shouldHide1: boolean = false;
    shouldHide2: boolean = true;
    shouldHide3: boolean = true;
    nomeCliente: any = '';
    hideLoginLoad: boolean = true;
    meusDados: any = '';
    dadosRecuperar: any = '';
    tentativasFail: any = 0;
    isPassword: boolean = true;
    idCliente: any = 0;
    fcmToken: any = '';
    formapro: any = '';
    Nutricionista:boolean = false;
    Treinador:boolean = false;
    Fisioterapeuta:boolean = false;
    Medico: boolean = false;
    Coach:boolean = false;
    arrPros: any[] = [];
    public maskNascimento = [ /[0-9]/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
    public maskTelefone = ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/,/\d/,/\d/, '-', /\d/, /\d/, /\d/, /\d/];

    constructor( public tmaService: TamasAlunoService, public router: Router, public dialog: MatDialog, private _location: Location, private piData: DatePipe) {}

    ngOnInit() {
        this.tmaService.eventoFS(true);
       setTimeout(() => {
           if(this.tmaService.logado == true){
                this.router.navigate(['home/']);
           }
           else{
               
            if(this.tmaService.paginaAnterior == 'cart/'){
                const avisoLogar = this.dialog.open(AlertaSimplesDialog, {
                    // width: '250px',
                    disableClose: true,
                    data: {textoAlerta: "Você deve efetuar o <b>login</b> para realizar o pedido.<br>Caso seja sua primeira vez aqui <b>efetue seu cadastro, é rápido!</b>"}
                });
            }
           }
            
       }, 0);
    }
    ngOnDestroy(){
        console.log("destroy");
        this.tmaService.eventoFS(false);
      }
    digitou(info: string) :void{
        console.log(info);
        this.email = info;
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.email);
        console.log("R " + re);
        
    }
    digitouEc(info: string) :void{

    }
    togglePW() :void{
        this.isPassword = !this.isPassword;
        console.log(this.isPassword);
    }
   
    novoCadastro() : void {
        console.log(this.celular.replace(/\_/g, '').replace(/\-/g, '').replace(/\ /g, '').replace('(', '').replace(')', '').length);
        console.log(this.celular);
        if (this.nome.length <= 3) {
            const nomeInsuf = this.dialog.open(AlertaSimplesDialog, {
                data: {textoAlerta: "Por favor insira seu nome"}
            });
            nomeInsuf.afterClosed().subscribe(qq1 =>{
                this.nomeInput.nativeElement.focus();
            });
            return ;
        }

        if (this.nascimento.length < 8) {
            const nascimentoInsuf = this.dialog.open(AlertaSimplesDialog, {
                data: {textoAlerta: "Para continuar informe a data de nascimento"}
            });
            nascimentoInsuf.afterClosed().subscribe(qq1 =>{
                this.nascimentoInput.nativeElement.focus();
            });
            return ;
        }

        if(this.genero == ''){
            const generoInsu = this.dialog.open(AlertaSimplesDialog, {
                data: {textoAlerta: "Para continuar por favor informe o seu <b>gênero</b>"}
            });
            return ;
        }
      

        if (this.celular.length < 10) {
            const celularInsuf = this.dialog.open(AlertaSimplesDialog, {
                data: {textoAlerta: "Por favor digite o celular  com DDD"}
            });
            celularInsuf.afterClosed().subscribe(qq1 =>{
                this.celularInput.nativeElement.focus();
            });
            return ;
        }
        else{
            //confirmar numero digitado 
            if(this.celular != this.celular2){
                const celularInsuf = this.dialog.open(AlertaSimplesDialog, {
                    data: {textoAlerta: "Por favor confirme o número do celular"}
                });
                celularInsuf.afterClosed().subscribe(qq1 =>{
                    this.celularInput.nativeElement.focus();
                });
            }
        }

        if (this.email == '') {
            const emailInsuf = this.dialog.open(AlertaSimplesDialog, {
                data: {textoAlerta: "Por favor insira seu e-mail"}
            });
            emailInsuf.afterClosed().subscribe(qq1 =>{
                this.emailInput.nativeElement.focus();
            });

            return ;
        }
        else {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.email);
            console.log("R " + re);
            if (re !== true) {
                const emailInv = this.dialog.open(AlertaSimplesDialog, {
                    data: {textoAlerta: "E-mail invalido, por favor verifique se digitou corretamente"}
                });
                return ;
            }
        }

        if (this.emailconf == '') {
            const emailInsuf = this.dialog.open(AlertaSimplesDialog, {
                data: {textoAlerta: "Por favor insira seu e-mail"}
            });
            emailInsuf.afterClosed().subscribe(qq1 =>{
                this.emailconfInput.nativeElement.focus();
            });

            return ;
        }
        else {
            if (this.email !== this.emailconf) {
                const emaildiff = this.dialog.open(AlertaSimplesDialog, {
                    data: {textoAlerta: "Por favor verifique se digitou corretamente o e-mail"}
                });
                return ;
            }
        }

        if (this.senha.length < 6) {
            const senhaInsuf = this.dialog.open(AlertaSimplesDialog, {
                data: {textoAlerta: "Sua senha deve ter pelo menos 6 digitos"}
            });
            return ;
        }
        
        //this.hideLoginLoad = false;


        if (this.newsletter === true) {
            console.log("Sim");
        }
        else {
            console.log("Não");
        }

        var itens = [];
        var tk = '';
        if (localStorage.getItem('tmsToken') != null) {
            itens = JSON.parse(localStorage.getItem('tmsToken'));
            tk = itens['token'];
            //console.log(itens);
        }
     
        var txtProfs = "";
        
        // if(this.Nutricionista) this.arrPros.push({ profissao: 'Nutricionista'});
        // if(this.Treinador) this.arrPros.push({ profissao: 'Treinador'});
        // if(this.Fisioterapeuta) this.arrPros.push({ profissao: 'Fisioterapeuta'});
        // if(this.Coach) this.arrPros.push({ profissao: 'Coach'});

        if(this.Nutricionista) txtProfs += "Nutricionista,";
        if(this.Treinador) txtProfs += "Educador Físico,";
        if(this.Fisioterapeuta)  txtProfs += "Fisioterapeuta,";
        if(this.Medico) txtProfs += "Médico,";
        if(this.Coach)  txtProfs += "Coach,";


        //arrPro = JSON.stringify({'profissao': });
        var gonnaPro = false;
        if(this.formapro == 'Sim') gonnaPro = true;

        console.log(txtProfs);
        console.log(txtProfs.substring(0, txtProfs.lastIndexOf(",")));

        var qProfissoes = txtProfs.substring(0, txtProfs.lastIndexOf(","));

        var qUserAgent = "";
        console.log(window.navigator.userAgent);
        console.log(/Macintosh|iPad|iPhone/.test(window.navigator.userAgent));
        if(/Macintosh|iPad|iPhone/.test(window.navigator.userAgent)){
          qUserAgent = "iOS";
        }
        else{
          qUserAgent = "Web";
        }


        const avisoCel =  this.dialog.open(AlertaConfirmDialog, {
            // width: '250px',
            disableClose: true,
            data: {tituloAlerta: "Aviso",  textoAlerta: "Enviaremos um SMS para validar seu cadastro.<br>O número de celular <b>" + this.celular + "</b> está correto?<br>", textoCancel: "Não", textoConfirm: "Sim"}
          });
          avisoCel.afterClosed().subscribe((result) =>{
            console.log(result);
            if(result == true){
              //continuar
              let postParams = {
                nome: this.nome, 
                email: this.email,
                celular: this.celular.replace(/\_/g, ''),
                datanascimento: this.nascimento,
                senha: this.senha,
                newsletter: this.newsletter,
                token: tk,
                versaoApp: "1.0.1",
                sistemaApp: qUserAgent,
                sexo: this.genero,
                profissional: gonnaPro,
                profissoes: qProfissoes
            }
    
    
    
            console.log("Stringify");
            //console.log(JSON.stringify(postParams));
            //console.log("Encoded");
            //console.log(encodeURIComponent(JSON.stringify(postParams)));
            //console.log(localStorage.getItem('turboCart'));
            this.hideLoginLoad = false;
            this.tmaService.addNovoUsuario(postParams).subscribe((data) =>{
                this.hideLoginLoad = true;
                console.log(data);
                if (data['res'] == 'done' || data['res'] == 'Confirmar Codigo') {
                    this.idCliente =  data['id'];
                    //redireciona para a tela de inserção do código;
                    this.tmaService.hcNome = this.nome;
                    this.tmaService.hcEmail = this.email;
                    this.tmaService.hcSenha = this.senha;
                    this.router.navigate(['/meu-cadastro/s/2/' + this.idCliente + '/null']);
    
                   
                }
                else {
                    if (data['res'] == 'already') {
                        const erroEmail = this.dialog.open(AlertaSimplesDialog, {
                            data: {textoAlerta: "E-mail já cadastrado no sistema. Efetue o login ou utilize <b>outro e-mail</b> para realizar o cadastro!", iconAlerta: 'warning'}
                        });
                        return;
                    }
                    if (data['res']== 'Telefone Cadastrado') {
                        const erroEmail = this.dialog.open(AlertaSimplesDialog, {
                            data: {textoAlerta: "Celular já cadastrado no sistema. Caso tenha esquecido sua senha recupere-a, se preferir utilize outro número de celular para realizar o cadastro!", iconAlerta: 'warning'}
                        });
                        return;
                    }
                }
            },
            (error) => {
                this.hideLoginLoad = true;
                const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                  disableClose: true,
                  data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
                });
              });
            }
          });
               
    }


    voltar(): void{
        //this._location.back();
        if(this.tmaService.paginaAnterior == "abertura"){
            //this._location.back();
            this.router.navigate(['abertura']);
        }
        else{
            this.router.navigate(['/autenticar']);
            //this.router.navigate(['/login']);
        }
        
    }

    openTermos() {
        const dialogRef = this.dialog.open(AlertaTermosDialog, {autoFocus: false });
        // dialogRef.afterClosed().subscribe(result => {
        //   console.log(`Dialog result: ${result}`);
        // });
    }
}
